
import axios from 'axios'
const getUsersList = async (
    token,
    sortBy,
    pageSize,
    pageIndex,
    filters,
    globalFilters
) => {
    globalFilters = globalFilters?.filter(
        (globalFilter) => globalFilter.value !== ''
    )
    filters = filters?.map((filter) => {
        let newValue = { ...filter.value }
        const newFilter = { ...filter }
        newValue.startDate = new Date(newValue.startDate)
        newValue.endDate = new Date(newValue.endDate)
        newFilter.value = newValue
        console.log({ newFilter })
        return newFilter
    })
    const result = await axios.get(
        `${import.meta.env.VITE_SERVER_BASE_URL}/users/list`,
        {
            params: {
                query: {
                    sortBy,
                    pageSize,
                    pageIndex,
                    filters,
                    globalFilters,
                },
            },
            headers: { Authorization: `Bearer ${token}` },
        }
    )

    return result.data
}

const getUser = async (token, userId) => {
    const result = await axios.get(
        `${import.meta.env.VITE_SERVER_BASE_URL}/users/${userId}`,
        {
            headers: { Authorization: `Bearer ${token}` },
        }
    )

    return result.data
}

const updateUser = async (token, userId, updatedData) => {
    if(updatedData?.domains){
        updatedData.domains = updatedData.domains.map((domain) => {
            // Create new domain object with cleaned industry if needed
            if (domain?.industry && domain.industry.domains !== undefined) {
                const { domains, ...industryWithoutDomains } = domain.industry;
                return { ...domain, industry: industryWithoutDomains, id: domain.id };
            }
            return domain;
        }).map((domain) => domain.id);
    }
    const result = await axios.put(
        `${import.meta.env.VITE_SERVER_BASE_URL}/users/${userId}`,
        {
            user: updatedData,
        },
        { headers: { Authorization: `Bearer ${token}` } }
    )

    return result.data
}
const updateAdminsDomains = async (token, updatedData) => {
    const result = await axios.put(
        `${import.meta.env.VITE_SERVER_BASE_URL}/users/update/admins-domains`,
        {
            user: updatedData,
        },
        { headers: { Authorization: `Bearer ${token}` } }
    )

    return result.data
}

const createUser = async (token, data) => {
    const result = await axios.post(
        `${import.meta.env.VITE_SERVER_BASE_URL}/users/create`,
        {
            user: data,
        },
        { headers: { Authorization: `Bearer ${token}` } }
    )

    return result.data
}

const deleteUser = async (token, roleId) => {
    const result = await axios.delete(
        `${import.meta.env.VITE_SERVER_BASE_URL}/users/${roleId}`,
        { headers: { Authorization: `Bearer ${token}` } }
    )

    return result.data
}

const getUsersPossibleValues = async (token) => {
    if (!token) throw new Error('No token')
    const result = await axios.get(
        `${import.meta.env.VITE_SERVER_BASE_URL}/users/values`,
        {
            headers: { Authorization: `Bearer ${token}` },
        }
    )

    return result.data
}

export {
    getUsersList,
    getUser,
    updateUser,
    createUser,
    deleteUser,
    getUsersPossibleValues,
    updateAdminsDomains
}
